import { render } from "./login.vue?vue&type=template&id=cef706d0&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=cef706d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cef706d0"

export default script